import { AboutContainer, Title, Paragraph, MiniTitle } from '../styled';
import {
  VisionMissionBox,
  VisionContainer,
  VisionImage,
  VisMisBox,
  VisionImageContainer,
} from './styled';

const Vision = () => (
  <AboutContainer>
    {/* @ts-expect-error */}
    <Title align="center" mb="50px">
      Visi & Misi Perusahaan
    </Title>
    <VisionContainer align="center">
      <VisionMissionBox>
        <VisionImageContainer>
          <VisionImage src="/images/vision.svg" />
        </VisionImageContainer>
        <VisMisBox>
          <MiniTitle>Visi Perusahaan</MiniTitle>
          <Paragraph>
            Membantu masyarakat Indonesia mencapai masa depan yang lebih baik
            melalui investasi.
          </Paragraph>
        </VisMisBox>
      </VisionMissionBox>
    </VisionContainer>
    <VisionContainer>
      <VisionMissionBox>
        <VisionImageContainer>
          <VisionImage src="/images/mission.svg" />
        </VisionImageContainer>
        <VisMisBox>
          <MiniTitle>Misi Perusahaan</MiniTitle>
          <Paragraph>
            <ul>
              <li>
                Menyediakan sarana investasi pasar modal yang mudah, aman dan
                nyaman untuk pemula.
              </li>
              <li>
                Meningkatkan literasi keuangan dengan meningkatkan edukasi dan
                kesadaran berinvestasi.
              </li>
              <li>
                Berkontribusi dalam menciptakan layanan jasa keuangan di bidang
                pasar modal yang inklusif.
              </li>
            </ul>
          </Paragraph>
        </VisMisBox>
      </VisionMissionBox>
    </VisionContainer>
  </AboutContainer>
);

export default Vision;
